import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import styled from 'styled-components'
const Field = styled.input`
display: flex;
justify-content : flex-start;
background-color : ${props => props.backgroundColor ? props.backgroundColor : props.disabled ? props.theme.disable : props.theme.white} ;
direction : ${props => props.lang === 'fa' || props.lang === 'ar' ? 'rtl' : 'ltr'};
border-radius : ${props => props.borderRdius || props.theme.buttonRadius} ;
width : ${props => props.width || '100%'} ;
height : ${props => props.height || '35px'} ;
color : ${props => props.color || props.theme.text} ;
font-size : ${props => props.fontSize || props.theme.fontSizeMd} ;
outline : none !important ;
border : ${props => props.border || `1px solid ${props.theme.lightGray}`} ;
font-family : inherit ;
box-sizing : border-box;
cursor : ${props => props.disabled ? 'no-drop' : 'pointer'} ;
&:hover {
background-color : ${props => props.backgroundColor ? props.backgroundColor : props.disabled ? props.theme.disable : props.theme.white} ;
color : ${props => props.color || props.theme.text} ;
}
&::placeholder {
color : ${props => props.color || props.theme.lightGray} ;
}
`
const StyledInput = props => {
    const theme = useContext(ThemeContext)

    return (
        <Field
            // key={1}
            {...props}
            onChange={(e) => props.onChange(e)}
            ref={props.innerRef}
            // className={props.className}
            value={props.value}
            type={props.type}
            theme={theme}
        />
    )
}
export default StyledInput
